import React from "react";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import { withStyles } from "material-ui/styles";
import isMobile from "ismobilejs";
import { LinearProgress } from "material-ui/Progress";
import QuestionData from "assets/data/QuestionData";
import { isAnswer } from "utils/formatter";
import Dialog, {
  DialogActions,
  DialogContent
} from "material-ui/Dialog";
import Typography from "material-ui/Typography";
import storage from "utils/storage";

const browserStyles = theme => ({
  container: {
    margin: 20,
    padding: 20,
    backgroundColor: theme.palette.answer.backgroundColor,
    height: 570,
    position: "relative"
  },
  qLabel: {
    marginLeft: 50,
    fontSize: "1.7rem"
  },
  main: {
    padding: "0 40px 10px",
    position: "relative"
  },
  labelDiv: {
    margin: "20px 40px"
  },
  label: {
    fontSize: "1.6rem",
    borderBottom: `5px solid ${theme.palette.answer.borderColor}`,
    padding: "3px 20px"
  },
  question: {
    display: "table",
    float: "left",
    border: `10px solid ${theme.palette.answer.borderColor}`,
    backgroundColor: "white",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    textAlign: "center",
    fontSize: "1.2rem",
    width: 550,
    height: 350,
    position: "relative",
    marginRight: 20,
    left: "10%"
  },
  questionText: {
    display: "table-cell",
    verticalAlign: "middle",
    fontSize: "2rem",
    padding: 20
  },
  buttonsDiv: {
    float: "left",
    width: 350,
    position: "relative",
    marginTop: 8,
    left: "10%"
  },
  buttonsGrid: {
    display: "flex",
    flexDirection: "column"
  },
  basicBtn: {
    margin: 8,
    height: 55,
    fontSize: "1.4rem"
  },
  basicButtonRaised: {
    backgroundColor: theme.palette.answer.main,
    "&:hover": {
      backgroundColor: theme.palette.answer.light
    }
  },
  progressWrapper: {
    position: "absolute",
    bottom: 100,
    width: "100%",
    margin: "0 -20px"
  },
  progress: {
    padding: "0 30px"
  },
  progressLabel: {
    margin: "0 10px"
  },
  progressBar: {
    height: 30,
    borderRadius: 10
  },
  progressBarColor: {
    backgroundColor: theme.palette.answer.light
  },
  footer: {
    position: "absolute",
    bottom: 15,
    margin: 10,
    width: "95%"
  },
  devBtn: {
    marginLeft: 20
  },
  clear: {
    clear: "both"
  },
  btnGroup: {
    display: "flex",
    justifyContent: "space-between"
  },
  tempSaveBtn: {
    display: "flex",
  }
});

const mobileStyles = theme => ({
  container: {
    margin: 10,
    padding: 10,
    backgroundColor: theme.palette.answer.backgroundColor
  },
  question: {
    marginBottom: 10,
    minHeight: 56
  },
  questionText: {
    borderBottom: `2px solid ${theme.palette.answer.borderColor}`,
    padding: "3px 10px"
  },
  basicButtonRaised: {
    backgroundColor: theme.palette.answer.main,
    "&:hover": {
      backgroundColor: theme.palette.answer.light,
      // Reset on mouse devices
      "@media (hover: none)": {
        backgroundColor: theme.palette.answer.main
      }
    }
  },
  buttonsDiv: {
    margin: 10,
    minHeight: 190
  },
  buttonsGrid: {
    display: "grid"
  },
  basicBtn: {
    margin: 5
  },
  progressWrapper: {
    margin: "10px 10px 30px"
  },
  progress: {
    padding: "0 10px"
  },
  progressLabel: {
    margin: "0 10px"
  },
  progressBar: {
    borderRadius: 10
  },
  progressBarColor: {
    backgroundColor: theme.palette.answer.light
  },
  devBtn: {
    marginLeft: 20
  }
});

const BasicButton = props => {
  const { children, classes, onClick } = props;

  return (
    <Button
      raised
      onClick={onClick}
      className={classes.basicBtn}
      classes={{ raised: classes.basicButtonRaised }}
    >
      {children}
    </Button>
  );
};

class SurveyReady extends React.Component {
  state = {
    temporarySave: false,
    showSavedDialog: false,
  };

  openTemporarySaveDialog = () => {
    this.setState({ temporarySave: true });
  };

  closeTemporarySaveDialog = () => {
    this.setState({ temporarySave: false });
  };

  confirmTemporarySave = (attrResult, basicResult, additionResult, qNo) => {
    let filteredBasic = {};
    let filteredAddition = {};
  
    if (qNo > 63) {
      // include ALL basic
      filteredBasic = basicResult;
  
      // include addition where key < qNo
      filteredAddition = Object.fromEntries(
        Object.entries(additionResult).filter(([key]) => Number(key) < qNo)
      );
    } else {
      // include basic where key < qNo
      filteredBasic = Object.fromEntries(
        Object.entries(basicResult).filter(([key]) => Number(key) < qNo)
      );
  
      // no addition for pages <= 63
      filteredAddition = {};
    }
    const { locale } = this.props;
    const params = {
      tempSavedPath: "/answer_question",
      basicResult: filteredBasic,
      additionResult: filteredAddition,
      attrResult: attrResult,
      localeId: locale.id,
      url: storage.getUrlToken(),
      token: storage.getToken(),
      survey_id: storage.getSurveyId()
    };
    window.removeEventListener('beforeunload', this.showReloadAlert);
    this.props.startTemporarySave(params)
    .then(() => {
      // Close first dialog
      this.setState({ temporarySave: false });
  
      // Show second dialog
      this.setState({ showSavedDialog: true });
    })
    .catch(() => {
      // Optionally handle error
    });
  };

  componentWillMount() {
    const { answerToken } = this.props.answerHeader;

    if (answerToken) {
      if (isAnswer()) {
        window.addEventListener('beforeunload', this.showReloadAlert);
      }
    } else {
      // answerTokenなしは認証エラー
      this.props.showErrorDialog();
    }
  }

  componentWillUnmount() {
    if (isAnswer()) {
      window.removeEventListener('beforeunload', this.showReloadAlert);
    }
  }

  showReloadAlert(e) {
    e.returnValue = '回答は削除されます。';
  }

  clickBasicBtn(num) {
    const { isEffecting } = this.props;
    if (!isEffecting) {
      const { currentQuestion, questions } = this.props.answerQuestion;

      this.props.clickBasicBtn(currentQuestion, num, questions.length);
    }
  }

  clickAdditionBtn(choice) {
    const { isEffecting } = this.props;
    if (!isEffecting) {
      const { currentQuestion, questions } = this.props.answerQuestion;

      this.props.clickAdditionBtn(currentQuestion, choice, questions.length);
    }
  }

  choiseSentence(id) {
    const { locale } = this.props;
    return QuestionData.CHOICES[locale.key].answers.find(
      (answer) => answer.id === id
    ).name;
  }

  render() {
    // 認証トークンがなければ画面の描写をしない
    if (!this.props.answerHeader.answerToken) {
      return null;
    }

    const {
      classes,
      answerQuestion,
      isEffecting,
      location,
      answerResult,
    } = this.props;
    const { currentQuestion, questions, basicQuestionCount } = answerQuestion;
    const { isRespondent } = this.props.answerStart;
    const { qNo, text } = currentQuestion;
    const { handlePrevBtn, handleDevBtn } = this.props; // action
    const id = storage.getSurveyId();

    return (
      <div>
        <Dialog
          open={this.state.temporarySave}
          onClose={this.closeTemporarySaveDialog}
          PaperProps={{
            style: {
              padding: '30px',
              borderRadius: '8px',
            },
          }}
        >
          <DialogContent
            style={{
              marginTop: '10px',
              textAlign: 'center',
              borderBottom: 'none',
            }}
          >
            <Typography
              variant='body1'
              style={{ fontSize: '1.6rem', lineHeight: '2.4rem' }}
            >
              回答を一時保存して中断します。
              <br />
              よろしいですか？
            </Typography>
          </DialogContent>

          <DialogActions
            style={{
              justifyContent: 'space-between',
              padding: '20px 30px',
            }}
          >
            <Button
              raised
              onClick={this.closeTemporarySaveDialog}
            >
              キャンセル
            </Button>

            <Button
              raised
              onClick={() => {
                const {
                  attrResult,
                  basicResult,
                  additionResult,
                } = answerResult;
                this.confirmTemporarySave(
                  attrResult,
                  basicResult,
                  additionResult,
                  qNo
                );
              }}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.showSavedDialog}
          onClose={() => {}} // Disable click-outside close
          disableBackdropClick // IMPORTANT: Prevent outside close
          disableEscapeKeyDown // Prevent ESC key close
          PaperProps={{
            style: {
              padding: '30px',
              borderRadius: '8px',
            },
          }}
        >
          <DialogContent
            style={{
              marginTop: '10px',
              textAlign: 'center',
              borderBottom: 'none',
            }}
          >
            <Typography
              variant='body1'
              style={{ fontSize: '1.6rem', lineHeight: '2.4rem' }}
            >
              一時保存しました。
            </Typography>
          </DialogContent>

          <DialogActions style={{ justifyContent: 'center', paddingTop: 20 }}>
            <Button
              raised
              style={{
                padding: '10px 50px',
              }}
              onClick={() => {
                this.setState({ showSavedDialog: false });
                this.props.confirmedTemporarySave();
              }}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
        <Paper className={classes.container}>
          <div className={classes.qLabel}>Q{qNo}</div>

          <div className={classes.main}>
            <div className={classes.question}>
              <div className={classes.questionText}>{text}</div>
            </div>

            {qNo <= basicQuestionCount && (
              <div className={classes.buttonsDiv}>
                <div className={classes.buttonsGrid}>
                  <BasicButton
                    onClick={() => this.clickBasicBtn(1)}
                    classes={classes}
                  >
                    {this.choiseSentence(1)}
                  </BasicButton>

                  <BasicButton
                    onClick={() => this.clickBasicBtn(2)}
                    classes={classes}
                  >
                    {this.choiseSentence(2)}
                  </BasicButton>
                  <BasicButton
                    onClick={() => this.clickBasicBtn(3)}
                    classes={classes}
                  >
                    {this.choiseSentence(3)}
                  </BasicButton>
                  <BasicButton
                    onClick={() => this.clickBasicBtn(4)}
                    classes={classes}
                  >
                    {this.choiseSentence(4)}
                  </BasicButton>
                  <BasicButton
                    onClick={() => this.clickBasicBtn(5)}
                    classes={classes}
                  >
                    {this.choiseSentence(5)}
                  </BasicButton>
                </div>
              </div>
            )}

            {currentQuestion.qNo > basicQuestionCount && (
              <div className={classes.buttonsDiv}>
                <div className={classes.buttonsGrid}>
                  {currentQuestion.choices.map((choice) => (
                    <Button
                      key={choice.id}
                      raised
                      onClick={() => this.clickAdditionBtn(choice)}
                      className={classes.basicBtn}
                      classes={{ raised: classes.basicButtonRaised }}
                    >
                      {choice.label}
                    </Button>
                  ))}
                </div>
              </div>
            )}

            <div className={classes.clear} />
          </div>

          <div className={classes.progressWrapper}>
            <div className={classes.progress}>
              <div className={classes.progressLabel}>
                <span>{`${qNo} / ${questions.length}`}</span>
              </div>

              <LinearProgress
                mode='determinate'
                value={(qNo / questions.length) * 100}
                className={classes.progressBar}
                classes={{ primaryColorBar: classes.progressBarColor }}
              />
            </div>
          </div>

          <div className={classes.footer}>
            <div className={classes.btnGroup}>
              <div>
                <Button
                  raised
                  dense
                  onClick={() => {
                    if (!isEffecting) {
                      handlePrevBtn(currentQuestion.qNo);
                    }
                  }}
                >
                  {qNo === 1 ? '前へ' : '前の設問へ'}
                </Button>

                {process.env.NODE_ENV === 'development' && (
                  <Button
                    raised
                    dense
                    className={classes.devBtn}
                    onClick={handleDevBtn(63, 1)}
                  >
                    最後の方へ1(開発用)
                  </Button>
                )}

                {process.env.NODE_ENV === 'development' && (
                  <Button
                    raised
                    dense
                    className={classes.devBtn}
                    onClick={handleDevBtn(63, 2)}
                  >
                    最後の方へ2(開発用)
                  </Button>
                )}

                {process.env.NODE_ENV === 'development' && (
                  <Button
                    raised
                    dense
                    className={classes.devBtn}
                    onClick={handleDevBtn(63, 3)}
                  >
                    最後の方へ3(開発用)
                  </Button>
                )}

                {process.env.NODE_ENV === 'development' && (
                  <Button
                    raised
                    dense
                    className={classes.devBtn}
                    onClick={handleDevBtn(63, 4)}
                  >
                    最後の方へ4(開発用)
                  </Button>
                )}

                {process.env.NODE_ENV === 'development' && (
                  <Button
                    raised
                    dense
                    className={classes.devBtn}
                    onClick={handleDevBtn(63, 5)}
                  >
                    最後の方へ5(開発用)
                  </Button>
                )}
              </div>

              <div>
                {location.pathname === '/answer/answer_question' &&
                  (id != null || id != undefined) &&
                  isRespondent && (
                    <Button
                      raised
                      dense
                      className={classes.tempSaveBtn}
                      onClick={() => {
                        if (!isEffecting) {
                          this.openTemporarySaveDialog();
                        }
                      }}
                    >
                      {'一時保存'}
                    </Button>
                  )}
              </div>
            </div>
          </div>
        </Paper>
      </div>
    );
  }
}

export default withStyles(isMobile.any ? mobileStyles : browserStyles)(
  SurveyReady
);




// WEBPACK FOOTER //
// ./src/components/answer/AnswerQuestion.jsx